const PAGES = ['/', '/about', '/projects', '/resume', '/contact'];

const CONTACT = {
  email: 'contact@ajithjoseph.com',
  linkedin: 'https://www.linkedin.com/in/ajithjozef/',
  github: 'https://github.com/codzz',
  blog: 'https://blog.ajithjoseph.com/',
  location: 'Bengaluru, Karnataka, India',
};

// Text content works for both the early-preview and current WebMCP result shapes.
const asText = (value) => ({ content: [{ type: 'text', text: JSON.stringify(value) }] });

const TOOLS = [
  {
    name: 'list_projects',
    description: "List Ajith Joseph's portfolio projects with title, description, and link.",
    annotations: { readOnlyHint: true },
    execute: async () => {
      const { default: projects } = await import('./data/projects');
      return asText(projects.map(({ title, desc, link }) => ({ title, desc, link })));
    },
  },
  {
    name: 'get_contact_info',
    description: "Get Ajith Joseph's email, LinkedIn, GitHub, blog, and location.",
    annotations: { readOnlyHint: true },
    execute: async () => asText(CONTACT),
  },
  {
    name: 'open_ai_clone',
    description: "Open the on-page AI assistant that answers questions about Ajith Joseph's skills, experience, and availability.",
    execute: async () => {
      window.dispatchEvent(new CustomEvent('openChat'));
      return asText({ opened: true });
    },
  },
  {
    name: 'navigate_to_page',
    description: 'Navigate to a page of ajithjoseph.com.',
    inputSchema: {
      type: 'object',
      properties: { path: { type: 'string', enum: PAGES } },
      required: ['path'],
    },
    execute: async ({ path }) => {
      if (!PAGES.includes(path)) throw new Error(`Unknown page: ${path}`);
      window.location.assign(path);
      return asText({ navigating: path });
    },
  },
];

const registerWebMcpTools = () => {
  // WebMCP moved from navigator.modelContext to document.modelContext; support both.
  const modelContext = document.modelContext || navigator.modelContext;
  if (!modelContext || typeof modelContext.registerTool !== 'function') return;

  const controller = new AbortController();
  TOOLS.forEach((tool) => modelContext.registerTool(tool, { signal: controller.signal }));
  window.addEventListener('pagehide', () => controller.abort());
};

export default registerWebMcpTools;
